import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../styles/staff-onboarding/staff-onboarding.css";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import {
  fetchDeletedStaffData,
  fetchStaffOnboardingRequestsData,
  fetchStaffOffboardingData,
} from "../../redux/prospect-reducers/prospectSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import OnboardingRequestListings from "../../components/staff-onboarding/on-boarding-requests/OnboardingRequestListings";
import DeletedStaff from "./DeletedStaff";
import StaffOffBoardingTab from "./StaffOffBoardingTab";

const OnboardedStaff = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { staffOnboardingRequestsLoading } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    isActive: "",
    accountType: "",
    selectedOnboardingStatus: "",
    selectedFitnessProfileStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    account_type: allFilters.accountType?.value || "",
    approval_status: allFilters.isActive?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
    onboarding_status: allFilters.selectedOnboardingStatus?.value || "",
    biomax_status: allFilters.selectedFitnessProfileStatus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const handleTabSelect = () => {
    setIsPage(0);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    const trimmedSearch = allFilters.searchString?.trim();
    if (trimmedSearch) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: trimmedSearch }));
    }
  };

  function getOnboardingRequests(filters) {
    dispatch(
      fetchStaffOnboardingRequestsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDeletedStaff(filters) {
    dispatch(
      fetchDeletedStaffData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getStaffOffboarding(filters) {
    dispatch(
      fetchStaffOffboardingData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getOnboardingRequests(filters);
    getDeletedStaff(filters);
    getStaffOffboarding(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      account_type: allFilters.accountType?.value || "",
      approval_status: allFilters.isActive?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
      onboarding_status: allFilters.selectedOnboardingStatus?.value || "",
      biomax_status: allFilters.selectedFitnessProfileStatus?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.accountType,
    allFilters.isActive,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.selectedOnboardingStatus,
    allFilters.selectedFitnessProfileStatus,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: On Boarding Requiests">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"On Boarding Requests"}
              isReload={() => {
                getOnboardingRequests(filters);
                getDeletedStaff(filters);
                getStaffOffboarding(filters);
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="staff-onboarding"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={staffOnboardingRequestsLoading}
              // isReload={() => {
              //   getOnboardingRequests(filters);
              //   getDeletedStaff(filters);
              // }}
            />
          </Col>
        </Row>

        <div className="odm-tabs-new mt30">
          <Tabs onSelect={handleTabSelect}>
            <TabList>
              <Tab>Active Staff</Tab>
              <Tab>Deleted Staff</Tab>
              <Tab>Staff Off Boarding</Tab>
            </TabList>

            <TabPanel>
              <Row>
                <Col>
                  <OnboardingRequestListings
                    userInfoData={userInfoData}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    callFunction={() => {
                      getOnboardingRequests(filters);
                    }}
                  />
                </Col>
              </Row>
            </TabPanel>

            <TabPanel>
              <DeletedStaff
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                userInfoData={userInfoData}
                callFunction={() => {
                  getDeletedStaff(filters);
                }}
              />
            </TabPanel>

            <TabPanel>
              <StaffOffBoardingTab
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                userInfoData={userInfoData}
                callFunction={() => {
                  getStaffOffboarding(filters);
                }}
              />
            </TabPanel>
          </Tabs>
        </div>
      </Container>
    </HelmetWrapper>
  );
};

export default OnboardedStaff;
